import { FiSmartphone, FiMonitor } from "react-icons/fi";

/**
 * Illustration for projects that have no screenshots (e.g. NDA work):
 * device icons and the main technologies.
 *
 * @component
 * @param {object} project - A project from src/_data/projects.json.
 * @param {boolean} large - Bigger variant for the project details page.
 */

const ProjectArtwork = ({ project, large }) => (
  <div className={`projectArtwork${large ? " large" : ""}`} role="img" aria-label={`${project.title} — ${project.description}`}>
    <div className="artworkDevices">
      {project.platforms.includes("Web") && <FiMonitor />}
      {project.platforms.some((p) => p !== "Web") && <FiSmartphone />}
    </div>
    <ul className="artworkTech">
      {project.technologies.slice(0, 3).map((tech) => (
        <li key={tech}>{tech}</li>
      ))}
    </ul>
  </div>
);

export default ProjectArtwork;
